import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { likeAPK, downloadAPK } from "../../apkStoreAPI";

export default function APKCard({ apk }) {
  const navigate = useNavigate();
  const [likes, setLikes] = useState(apk.likes?.length || 0);
  const [downloads, setDownloads] = useState(apk.downloads || 0);

  const handleLike = async (e) => {
    e.stopPropagation();
    try {
      await likeAPK(apk._id);
      setLikes(likes + 1);
    } catch (error) {
      console.error("Erro ao curtir:", error);
    }
  };

  const handleDownload = async (e) => {
    e.stopPropagation();
    try {
      await downloadAPK(apk._id);
      setDownloads(downloads + 1);
      alert("Download registrado! Link: " + (apk.apkUrl || "Não disponível"));
    } catch (error) {
      console.error("Erro ao baixar:", error);
    }
  };

  return (
    <div className="apk_card" onClick={() => navigate(`/apk/${apk._id}`)}>
      <div className="apk_card_icon">
        {apk.icon ? (
          <img src={apk.icon} alt={apk.appName} />
        ) : (
          <div className="apk_card_icon_placeholder">📱</div>
        )}
      </div>
      <div className="apk_card_content">
        <h3 className="apk_card_title">{apk.appName}</h3>
        <p className="apk_card_developer">
          {apk.developer?.first_name} {apk.developer?.last_name}
        </p>
        <div className="apk_card_rating">
          <span className="apk_rating_stars">⭐ {apk.rating?.average?.toFixed(1) || "N/A"}</span>
          <span className="apk_rating_count">({apk.rating?.totalRatings || 0})</span>
        </div>
        <div className="apk_card_stats">
          <span>📥 {downloads}</span>
          <span>❤️ {likes}</span>
        </div>
        {apk.priceType === "paid" && (
          <div className="apk_card_price">
            {apk.currency} {apk.price?.toFixed(2)}
          </div>
        )}
        {apk.priceType === "free" && (
          <div className="apk_card_price_free">GRÁTIS</div>
        )}
      </div>
      <div className="apk_card_actions">
        <button onClick={handleLike} className="apk_btn_like">❤️</button>
        <button onClick={handleDownload} className="apk_btn_download">📥 Baixar</button>
      </div>
    </div>
  );
}
